import { createContext, useState } from "react";
import { useDispatch } from "react-redux";

import {
  getBackUpService,
  getBackUpsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import { getCookies } from "../../../utils";


export const backUpAdminContext = createContext({
  backUps: [],
  setBackUps: () => {},
  handleGetBackUps: () => {},
  handleGetBackUp: () => {},
});

const BackUpAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [backUps, setBackUps] = useState([]);

  // Handle Get Back Ups Method
  const handleGetBackUps = async (event) => {
    event?.preventDefault();

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getBackUpsService();
      if (status === 200) {
        setBackUps(data.files);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Back Up Method via Native Browser Streaming
  const handleGetBackUp = (name) => {
    // 1. Grab your active auth token from wherever it's stored (localStorage, cookie, or Redux)
    const token = getCookies("accessToken");

    if (!token) {
      toastErrorMessage("Authentication token missing.");
      return;
    }

    // 2. Build the explicit direct download link targeting your Django View route
    // If your API prefix points elsewhere, ensure it matches your baseUrl profile
    const downloadUrl = `https://karbama.app/api/admin/v2/backups/${name}/?token=${token}`;

    // 3. Create an invisible anchor tag and trigger native streaming click
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", name);
    
    // Forces the browser to handle it as an independent network request stream
    link.target = "_blank"; 
    
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <backUpAdminContext.Provider
      value={{
        backUps,
        setBackUps,
        handleGetBackUps,
        handleGetBackUp,
      }}
    >
      {children}
    </backUpAdminContext.Provider>
  );
};

export default BackUpAdminContext;
